import * as React from "react";
import Select from "react-select";
export class EndorsementFilterComponent extends React.Component {
    render() {
        const { t, filter } = this.props;
        const selectionFilters = ["Endorsed", "Abstained", "Undecided", "N/A"];
        const currentFilters = selectionFilters.map((current) => ({
            label: t(current),
            value: current,
        }));
        return (React.createElement(Select, { className: "select-compact", options: currentFilters, value: filter || "", onChange: this.changeFilter, autosize: false, placeholder: t("Select...") }));
    }
    changeFilter = (value) => {
        const { attributeId, onSetFilter } = this.props;
        onSetFilter(attributeId, value !== null ? value.value : null);
    };
}
class EndorsementFilter {
    component = EndorsementFilterComponent;
    raw = false;
    matches(filter, value) {
        if (filter === null) {
            return true;
        }
        if (value === "") {
            return filter.toLowerCase() === "undecided";
        }
        else if (value === undefined) {
            return filter === "N/A";
        }
        else {
            return filter.toLowerCase() === value?.toLowerCase?.();
        }
    }
}
export default EndorsementFilter;
